import { flowApi } from '.';
import { TAG_TYPES } from 'types/services';
import type { GetAgendasFormItemsReq, GetAgendasFormItemsRes, GetAgendasFormRes, TabSection as TabSectionReq } from 'types';

export const formService = flowApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getAgendasForms: builder.query<GetAgendasFormRes, { agendaId: string }>({
      query: ({ agendaId }) => ({
        url: `Agendas/${agendaId}/Form`,
        method: 'GET',
      }),
      providesTags: (_result, _error, { agendaId }) => [{ type: TAG_TYPES.AGENDAS, id: agendaId }],
    }),
    getAgendasFormItems: builder.query<GetAgendasFormItemsRes, GetAgendasFormItemsReq>({
      query: ({ agendaId }) => ({
        url: `Agendas/${agendaId}/FormItems`,
        method: 'GET',
      }),
      providesTags: (_result, _error, { agendaId }) => [{ type: TAG_TYPES.AGENDAS, id: agendaId }],
    }),
    updateOrCreateAgendaForm: builder.mutation<
      unknown,
      {
        agendaId: string;
        tabSections: TabSectionReq[];
      }
    >({
      query: ({ agendaId, tabSections }) => ({
        url: `Agendas/${agendaId}/Form`,
        method: 'PUT',
        body: { tabSections },
        headers: { 'x-api-version': '2.0' },
      }),
      invalidatesTags: (_result, _error, { agendaId }) => [
        { type: TAG_TYPES.AGENDAS, id: agendaId },
        { type: TAG_TYPES.CONDITIONS, id: 'DETAIL' },
        TAG_TYPES.LOOKUPS,
        { type: TAG_TYPES.RECORDS, id: 'DETAIL' },
      ],
    }),
  }),
});
export const {
  useGetAgendasFormItemsQuery,
  useLazyGetAgendasFormItemsQuery,
  useGetAgendasFormsQuery,
  useLazyGetAgendasFormsQuery,
  useUpdateOrCreateAgendaFormMutation,
} = formService;
